import ApiService, { ACCOUNTS_API_HOST } from './ApiService';

/**
 * @override
 */
class ProductsService extends ApiService {
    /**
     * constructor
     */
    constructor() {
        super({ baseURL: ACCOUNTS_API_HOST });
    }
    /**
     * Get products list
     * @param {Object} config Axios config
     * @return {Object} Response with list of products
     */
    getProducts(config) {
        // marcamos limit y offset a null para eliminarlos en el ApiService. REVISAR LIMITS DE LA APLICACIÓN
        config.params['$limit'] = 'null';
        config.params['$offset'] = 'null';
        return this.getList('/products', config);
    }
    /**
     * Get products list
     * @param {String} keyName product key name
     * @param {Object} config Axios config
     * @return {Object} Response with product data
     */
    getProduct(keyName, config) {
        return this.getList(`/products/${keyName}`, config);
    }
}

const productsService = new ProductsService();

export default productsService;
